import { useMsal } from '@azure/msal-react'
import {
  Body2,
  Box,
  Button,
  ButtonGroup,
  Display3,
  Flex,
} from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import React, { useEffect } from 'react'

import ProductionPlanningHeader from './PlannerSelection/ProductionPlanningHeader'

const ErrorPage = () => {
  const { instance } = useMsal()

  const onReload = () => {
    window.location.href = window.location.origin
  }

  useEffect(() => {
    console.info('ErrorPage - Production Planning is unavailable.', {
      online: navigator?.onLine,
    })
  }, [])

  return (
    <>
      <Box
        className='main-error-page'
        backgroundColor='primary'
        style={{ width: '100%', margin: 0, padding: 0, minHeight: '100vh' }}
        testid='error-page'
      >
        <Box
          backgroundColor='secondary'
          border={{ radius: 'md', size: 'md' }}
          style={{ width: '100%' }}
        >
          <ProductionPlanningHeader headerMessage={'Production Planning'} />
        </Box>
        <Flex
          direction='column'
          alignItems='center'
          gap='lg'
          style={{ minHeight: 'calc(100vh - 56px)' }}
        >
          <Box
            backgroundColor='secondary'
            padding={{ sm: 'md', md: 'lg' }}
            style={{
              maxWidth: 1800,
              width: '100%',
              marginTop: '2rem',
              boxSizing: 'border-box',
            }}
          >
            <Flex
              direction='column'
              alignItems='center'
              justifyContent='center'
              gap='sm'
            >
              <AlertCircleFilled className='c-common-error_icon-larger' />
              <div className='c-common-error_primaryMessage'></div>
              <Display3
                style={{
                  textAlign: 'center',
                  marginTop: '8px',
                  marginBottom: '16px',
                }}
              >
                Production Planning is unavailable.
              </Display3>
              <Body2 style={{ textAlign: 'center', margin: 0 }}>
                Sorry, we're having trouble loading Production Planning right
                now.
              </Body2>
              <Body2
                style={{
                  textAlign: 'center',
                  fontSize: '1.1rem',
                  margin: 0,
                  marginBottom: '16px',
                }}
              >
                Please try again.
              </Body2>
              <ButtonGroup align='center' gap='lg'>
                <Button onClick={onReload}>Try Again</Button>
                <Button
                  variant='secondary'
                  onClick={() => void instance.logoutRedirect()}
                  style={{
                    backgroundColor: 'var(--fable-color-background, #fff)',
                  }}
                  testid='logout-button'
                >
                  Logout
                </Button>
              </ButtonGroup>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  )
}

export default ErrorPage
